import { render, staticRenderFns } from "./DynamicLayout.vue?vue&type=template&id=276fe89a&scoped=true&"
import script from "./DynamicLayout.script.js?vue&type=script&lang=js&"
export * from "./DynamicLayout.script.js?vue&type=script&lang=js&"
import style0 from "./DynamicLayout.scss?vue&type=style&index=0&id=276fe89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276fe89a",
  null
  
)

export default component.exports